var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlookLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "yyxr58ngra",
    d: "M0 0h6.027v6.641H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1975BC",
    d: "M9.89 0 .5 1.62v12.584l9.39 1.84z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.473 5.22)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "197523rapb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yyxr58ngra"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.42v4.221h5.31s.778-.108.713-1.127L6.027 0l-3.89 2.632S1.037 3.52 0 2.42",
    fill: "#1975BC",
    mask: "url(#197523rapb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.473 3.257h5.354s.63-.044.63.642l-4.84 3.224-1.144-.73V3.258z",
    fill: "#1975BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.193 9.565c-.568 0-1.028-.755-1.028-1.686 0-.931.46-1.686 1.028-1.686.568 0 1.028.755 1.028 1.686 0 .931-.46 1.686-1.028 1.686m.025-4.527c-1.18 0-2.138 1.274-2.138 2.846 0 1.571.957 2.845 2.138 2.845s2.138-1.274 2.138-2.845c0-1.572-.957-2.846-2.138-2.846",
    fill: "#FEFEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookLogo);
export default __webpack_public_path__ + "static/media/outlook-logo.355e0804d92563f1a3ad9cbf9b3fbc66.svg";
export { ForwardRef as ReactComponent };